import { render, staticRenderFns } from "./tris-scroll-good.vue?vue&type=template&id=46ac3669"
import script from "./tris-scroll-good.vue?vue&type=script&lang=js"
export * from "./tris-scroll-good.vue?vue&type=script&lang=js"
import style0 from "./tris-scroll-good.vue?vue&type=style&index=0&id=46ac3669&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports